import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "panel-token-label" }

import TokenIcon from '@/components/token/TokenIcon.vue';
import { Token } from '@/sdk/entities/token';


export default /*#__PURE__*/_defineComponent({
  __name: 'TokenLabel',
  props: {
    token: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createVNode(TokenIcon, {
        "icon-src": __props.token.tokenIconUrl,
        symbol: __props.token.unwrapWETH().symbol,
        full: ""
      }, null, 8, ["icon-src", "symbol"])
    ])
  ]))
}
}

})